import React, { useState } from "react";
import ExtendedSelectField from "@src/stories/elements/ExtendedSelectField/ExtendedSelectField";  

const ExtendedProductProperty = ({ props }) => {
    console.log(props, 'props');
  const {
    property_name,
    property_label,
    property_placeholder,
    property_options = []
  } = props?.settings;


  console.log(property_options, 'property_options');

  const [selected, setSelected] = useState("");

  return (
    <div className={'product-variants-select flex flex-col gap-6 my-3'}>
      {property_options.length > 0 && (
        <>
          <div className={'product-variants-select__label'}> {property_label} </div>
          <ExtendedSelectField
            options={property_options.map((option) => ({
              value: option,
              label: option
            }))}
            placeholder={property_placeholder}
            onChange={(option) => setSelected(option.value)}
          />
        </>
      )}
      <input
        type="text"
        id={`line-item-${property_name}`}
        data-name={`${property_name}`}
        name={`properties[${property_name}]`}
        readOnly 
        value={selected}
        className="line-item-property hidden"
      />
    </div>
  );
};

export default ExtendedProductProperty;